const mockAppTrustData = {
  dataAccessNStorage: {
    isSameDataProcessedNStored: true,
    appProcessEUDOutsideAtlassian: true,
    typesOfDataAccessed: ['Email Address', 'Device ID', 'IP Address'],
    appStoresEUDOutsideAtlassian: true,
    typesOfDataStored: ['Email Address', 'Logs', 'Content posted, received or shared in the app by end-users']
  },
  thirdPartyInformation: {
    isEndUserDataShared: true,
    dataSubprocessors: '',
    thirdPartyDetails: [{
      name: 'Auth O',
      link: 'storage.segment.io',
      purpose: 'Chat technology and infrastructure provider',
      thirdPartyCountries: ['US', 'CA', 'CO', 'CG', 'CI', 'HR']
    }, {
      name: 'Google Analytics',
      link: 'analytics.google.com',
      purpose: 'For analytics',
      thirdPartyCountries: ['US', 'CO']
    }]
  },
  dataResidency: {
    isDataResidencySupported: 'STORED_EXTERNAL_TO_ATLASSIAN',
    countriesWhereEndUserDataStored: ['US', 'CA', 'CO', 'CG', 'CI'],
    inScopeDataTypes: ['Email address', 'Content posted, received or shared in the app by end-users'],
    realmMigrationSupported: true
  },
  dataRetention: {
    isDataRetentionSupported: true,
    retentionDurationInDays: {
      min: 10,
      max: 20
    },
    isCustomRetentionPeriodAllowed: true
  },
  logDetails: {
    logEndUserData: true,
    logProcessAndOrStoreEUDOutsideAtlassian: true,
    logEUDShareWithThirdParty: true,
    logsIntegralForAppFunctionality: true
  },
  compliantStandards: [{
    type: 'HIPPA',
    link: 'link goes here'
  }, {
    type: 'FedRAMP',
    link: 'link goes here'
  }, {
    type: 'SOC2',
    link: 'link goes here'
  }, {
    type: 'ISO27K',
    link: 'link goes here'
  }, {
    type: 'FinServ',
    link: 'link goes here'
  }],
  otherCompliantStandards: [{
    type: 'free text here',
    link: 'link goes here'
  }]
};
export default mockAppTrustData;